import { gql } from "@outschool/ui-apollo";

import MessageContentFragment from "../../shared/client/queries/MessageContentFragment";
import { LearnerPrivateNote } from "../components/learner/LearnerPrivateNote";
import LearnerFragment from "./LearnerFragment";

export const SenderFragment = gql`
  fragment SenderFragment on Sender {
    uid
    name
    photo
  }
`;

export const ParticipantFragment = gql`
  fragment ParticipantFragment on Participant {
    uid
    name
    photo
    timeZone
    headline
    leader_link
    isLearner
    ownerOfSellerOrg {
      uid
    }
    teacherForSellerOrg {
      uid
    }
    role
  }
`;

export const EnrollmentWithTeacherFragment = gql`
  fragment EnrollmentWithTeacherFragment on Enrollment {
    uid
    confirmed_at
    withdrawn_at
    ongoing_stopped_at
    ongoing_start_time
    ongoing_end_time
    isEnded
    isPaused
    section {
      uid
      start_time
      end_time
      activity {
        uid
        title
        titleTranslated
        isClub
        published_at
        is_ongoing_weekly
        weekly_meetings
        duration_weeks
      }
      nextOngoingMeeting {
        uid
        start_time
      }
    }
    learner {
      ...LearnerFragment
      ...LearnerPrivateNote_learner
    }
    pauseWindow {
      uid
      startDate
      endDate
    }
  }
  ${LearnerFragment}
  ${LearnerPrivateNote.fragments.learner}
`;

export default gql`
  fragment MessageFragment on Message {
    uid
    sender {
      ...SenderFragment
    }
    participants {
      ...ParticipantFragment
    }
    subject
    action
    content
    messageContent {
      ...MessageContentFragment
    }
    created_at
    activity_uid
    section_uid
    thread_uid
  }
  ${ParticipantFragment}
  ${SenderFragment}
  ${MessageContentFragment}
`;
